import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSvgComponent } from './svg.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [AppSvgComponent],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    MatIconModule
  ],
  exports: [AppSvgComponent]
})
export class SvgModule { }
